import { DecisionType, DecisionState, StatisticResponse, StatisticResponseWithCaseId, CaseResponse } from '@/types/types';
import {
	isSentToSmallSenate,
	isInStatements,
	isSentToWerberat,
	isSentToWerberat,
	hasDecision,
	isSmallSenateDecision,
} from '@/utils/casesHandling/cases';

export const getCurrentDecisions = (statistics: StatisticResponse | StatisticResponseWithCaseId, type?: DecisionType | null) => {
	if (!statistics || statistics.length === 0) return [];

	if (type === DecisionType.SmallSenate) {
		return statistics.decisions.filter((decision) => decision.decisionType === DecisionType.SmallSenate);
	} else if (type === DecisionType.JungerWerberat) {
		return statistics.decisions.filter((decision) => decision.decisionType === DecisionType.JungerWerberat);
	} else if (type === DecisionType.Werberat) {
		return statistics.decisions.filter((decision) => decision.decisionType === DecisionType.Werberat);
	} else {
		return statistics.decisions.filter((decision) => decision.decisionType !== DecisionType.SmallSenate);
	}
};

export const getParsedDecisions = (statistics: StatisticResponse | StatisticResponseWithCaseId, type: DecisionType) => {
	if (!statistics || statistics.length === 0 || !type) return null;

	const currentDecisions = getCurrentDecisions(statistics, type);
	if (!currentDecisions) return null;

	return currentDecisions.map((decision) => {
		return {
			...decision,
			decisionType: decision.decisionType === DecisionType.JungerWerberat ? 'Junger Werberat' : DecisionType.Werberat,
		};
	});
};

export const getWerberatDecisionsCount = (statistics: StatisticResponse | StatisticResponseWithCaseId) => {
	if (!statistics) return 0;
	return statistics.decisions
		.filter(
			(decision) =>
				decision.decisionType === DecisionType.Werberat &&
				decision.decisionState !== DecisionState.Null &&
				decision.decisionState !== DecisionState.UserAbsent,
		)
		.reduce((acc, decision) => acc + decision.count, 0);
};

export const showSmallSenateStatistic = (data: CaseResponse) => {
	if (!data) return false;
	if ((isSentToSmallSenate(data) || isInStatements(data)) && !isSentToWerberat(data)) {
		return true;
	}
	return false;
};

export const showWerberatStatistic = (data: CaseResponse) => {
	if (!data) return false;
	if ((isSentToWerberat(data) || hasDecision(data)) && !isSmallSenateDecision(data)) {
		return true;
	}
	return false;
};
